<script setup lang="ts">
type Emits = {
  (e: "close"): void;
};

defineEmits<Emits>();

const localePath = useLocalePath();
</script>

<template>
  <BaseModal
    size="md"
    class="address-required-wrapper"
    data-cy="address-required-modal"
    @close="$emit('close')"
  >
    <h2 class="text-xl md:text-2xl font-bold uppercase">
      {{ $t(`product.addressModal.header`) }}
    </h2>
    <div class="text-sm md:text-base pt-2 pb-4">
      {{ $t(`product.addressModal.body`) }}
    </div>
    <NuxtLink
      id="address-required-button"
      tag="button"
      class="base-button text-center text-sm md:text-base"
      :to="
        localePath({
          path: '/my-account/settings/addresses',
        })
      "
      aria-label="Bidding not possible"
      data-cy="address-required-button"
    >
      {{ $t(`product.addressModal.editAddress`) }}
    </NuxtLink>
    <BaseButton
      id="address-required-close-button"
      color-scheme="secondary"
      class="address-required-wrapper__button"
      data-cy="address-required-modal-close"
      @click="$emit('close')"
    >
      {{ $t(`product.addressModal.close`) }}
    </BaseButton>
  </BaseModal>
</template>
